<div *ngIf="!verified" class="container-captcha is-block" [ngClass]="error ? 'is-error' : ''">
  <div class="loading m-auto" *ngIf="loading"></div>
  <div *ngIf="!loading" class="alert alert-warning">
    <h1 class="title">Ich bin kein Roboter.</h1>
    <h2 class="subtitle">{{question}}</h2>
    <div class="is-flex-tablet is-align-items-end is-justify-content-center">
      <div *ngFor="let answer of answers; let i = index " class="is-flex-grow-1 is-flex-shrink-1">
        <div class="container-answers ">
          <div *ngIf="answer.verify == true" class="ok">
            <fa-icon [icon]="faCheckCircle"></fa-icon>
          </div>
          <div *ngIf="answer.verify == false" class="error">
            <fa-icon [icon]="faExclamationTriangle"></fa-icon>
          </div>
          <img *ngIf="answer.verify == undefined" (click)="verify(answer.id)" class="answer"
               src="{{urlS3 + answer.img}}" alt=""/>
          <div class="helper"></div>
        </div>
      </div>
    </div>
  </div>
</div>
